import React from "react";
import { Modal as AntModal } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Slide } from "react-slideshow-image";
import { SimpleSlideImage } from "./../ProceedTopUp.style";

export const Modal = styled(AntModal)`
  .ant-modal-content {
    padding: 0;
    margin: 0;
    padding-top: 15px;
  }
  .ant-modal-title {
    text-align: center;
    color: #e9a94d;
    /* color:${(props) => props.theme.golden} !important; */
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 26px;
  }
`;

export const ModalFooterContainer = styled.div`
  height: 52px;
  display: flex;
  border-top: 2px solid #f4f1eb;
  background: ${(props) => props.theme.golden};
  :hover {
    background: ${(props) => props.theme.goldenVertical} !important;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.textColor};
  border-radius: 0 0 8px 8px;
  cursor: pointer;
`;

export const ModalTitle = styled.p`
  color: ${(props) => props.theme.primarySolid};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const ModalText = styled.p`
  color: #858585;
  font-weight: 400;
  font-size: 14px;
  display: block;
  margin-bottom: 20px;
  padding: 0 30px;
`;

export const SliderContainer = styled.div`
  text-align: center;

  .indicators {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
    padding: 0 !important;
  }

  .react-slideshow-container + ul.indicators {
    .each-slideshow-indicator:before {
      background: ${(props) => props.theme.primarySolid};
    }
  }
`;

const SimpleImageModal = ({
  open,
  onOk,
  receiving_account,
  active_topup_screenshot,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      centered
      destroyOnClose
      closable={false}
      open={open}
      width={350}
      footer={null}
    >
      <SliderContainer>
        {((!active_topup_screenshot && receiving_account?.payment_category_view_sample_images?.length > 0) ||
          (active_topup_screenshot && receiving_account?.payment_category_view_topup_images?.length > 0)) && (
            <Slide
              arrows={false}
              autoplay={true}
              indicators={true}
              duration={3000}
              transitionDuration={500}
            >
              {active_topup_screenshot
                ? receiving_account?.payment_category_view_topup_images?.map(
                  (image, key) => (
                    <SimpleSlideImage key={key} src={image} />
                  )
                )
                : receiving_account?.payment_category_view_sample_images?.map(
                  (image, key) => (
                    <SimpleSlideImage key={key} src={image} />
                  )
                )}
            </Slide>
          )}
        <ModalText>{!active_topup_screenshot && t("wallet.topupWarningLabel")}</ModalText>
      </SliderContainer>
      <ModalFooterContainer onClick={onOk}>
        {t("common.ok")}
      </ModalFooterContainer>
    </Modal>
  );
};

export default SimpleImageModal;
